<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-data-table :headers="headers" :items="rubrics_header_list" dense class="elevation-1 mytable" :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Rubrics Header</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="1" cols="12"> </v-col>
            <v-col sm="6" md="4" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>Add Rubrics Header</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field v-model="editedItem.rubrics_header_name" persistent-hint :hint="
                              editedIndex == -1
                                ? 'For example :: Experimentation, Yoga, Visual Arts...'
                                : 'For example ::  Experimentation, Yoga, Visual Arts...'
                            " label="Enter Rubrics Header" :rules="[(v) => !!v || 'required']">
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
        </template>
      </v-data-table>

      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },

  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      id: false,
    },
    snackbar_msg: "",
    // extraBreadcrumbItems: [
    //   { text: "Rubrics Header", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Rubrics Header",
        align: "left",
        sortable: false,
        value: "rubrics_header_name",
      },

      { text: "Actions", value: "action", sortable: false },
    ],
    rubrics_header_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      rubrics_header_name: "",
    },
    defaultItem: {
      id: "",
      rubrics_header_name: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Rubrics Header"
        : "Edit Rubrics Header";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.rubrics_header_name = false;
    },

    onLoad() {
      this.overlay = true;
      axios
        .post("/Examination/rubricsHeaderHome")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.rubrics_header_list = res.data.rubrics_header_list;
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.rubrics_header_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/Examination/editRubricsHeader", this.editedItem)
            .then((res) => {
              if (res.data.status == "YES") {
                Object.assign(
                  this.rubrics_header_list[this.editedIndex],
                  this.editedItem
                );
                this.onLoad();
                this.showSnackbar(
                  "#4caf50",
                  "Rubrics Header Updated Successfully..."
                ); // show snackbar on success
              } else if (res.data.status.code == "NA") {
                this.showSnackbar(
                  "#b71c1c",
                  "Rubrics Header Already Present!!!"
                ); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
        axios
          .post("/Examination/saveRubricsHeader", this.editedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.rubrics_header_list.push(this.editedItem);
              this.onLoad();
              this.showSnackbar(
                "#4caf50",
                "Rubrics Header Added Successfully..."
              ); // show snackbar on success
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Rubrics Header Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });

        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.rubrics_header_name) {
        return true;
      } else {
        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>